export const PrefixOptions = ["None", "Mr",
        "Mrs",
        "Ms",
        "Miss",
        "Dr",
        "Col",
        "Governor",
        "LT Gov",
        "Senator",
        "Rep"];
export const SuffixOptions = [
  'None',
  'CPO',
  'DDS',
  'DVM',
  'ESQ',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'Jr',
  'Sr',
  'MD',
  'PHD',
  'RPH',
];
export const AddressTypeOptions = ['Unknown', 'Home', 'Business', 'Mailing'];
export const PhoneNumberTypeOptions = [
  'Unknown',
  'Home',
  'Business',
  'Mobile',
  'Fax',
  'Assistant',
];

export const MembershipStatus = {
  None: 'None',
  Lapsed: 'Lapsed',
  Active: 'Active',
};

export const MembershipType = {
  None: 'None',
  Member: 'Member',
  Associate: 'Associate',
};

export default {
  AddressTypeOptions,
  PrefixOptions,
  SuffixOptions,
  PhoneNumberTypeOptions,
  MembershipStatus,
  MembershipType,
};



// WEBPACK FOOTER //
// ./src/common/option-lists.js